export default {
    heading: `'HelveticaNeueLTStd', sans-serif`,
    body: `'HelveticaNeueLTStd', sans-serif`
}
